// Safely read the current user's role from localStorage.
// The role is stored JSON-encoded at login (JSON.stringify(role)), so reading
// the raw value would yield a quoted string (e.g. "\"SUPER_ADMIN\"") that fails
// every role lookup. Always read it through this helper.
export const getUserRole = () => {
  try {
    return JSON.parse(localStorage.getItem("userRole") || '""')
  } catch (e) {
    return ""
  }
}

// Returns the logged-in user's profile (the object stored at login), or null
// if absent/unparseable. Plain function rather than a React hook so it can be
// called from anywhere — component bodies, handlers, or nested helpers — not
// just the top level of a component.
export const getAuthUser = () => {
  try {
    return JSON.parse(localStorage.getItem("authUser"))
  } catch (e) {
    return null
  }
}

// All platform role string constants
export const ROLES = Object.freeze({
  SUPER_ADMIN: "SUPER_ADMIN",
  NATIONAL_ALGON_ADMIN: "NATIONAL_ALGON_ADMIN",
  NATIONAL_ALGON_COORDINATOR: "NATIONAL_ALGON_COORDINATOR",
  STATE_ADMIN: "STATE_ADMIN",
  STATE_ALGON_CHAIRMAN: "STATE_ALGON_CHAIRMAN",
  LGA_FOCAL_PERSON: "LGA_FOCAL_PERSON",
  LGA_CHAIRMAN: "LGA_CHAIRMAN",
})

// Human-readable display labels for each role
export const ROLE_LABELS = Object.freeze({
  [ROLES.SUPER_ADMIN]: "Super Admin",
  [ROLES.NATIONAL_ALGON_ADMIN]: "National ALGON Admin",
  [ROLES.NATIONAL_ALGON_COORDINATOR]: "National ALGON Coordinator",
  [ROLES.STATE_ADMIN]: "State Admin",
  [ROLES.STATE_ALGON_CHAIRMAN]: "State ALGON Chairman",
  [ROLES.LGA_FOCAL_PERSON]: "LGA Focal Person",
  [ROLES.LGA_CHAIRMAN]: "LGA Chairman",
})

// Which roles each actor can create accounts for
export const CREATABLE_ROLES = Object.freeze({
  [ROLES.SUPER_ADMIN]: [
    ROLES.NATIONAL_ALGON_ADMIN,
    ROLES.NATIONAL_ALGON_COORDINATOR,
    ROLES.STATE_ADMIN,
    ROLES.STATE_ALGON_CHAIRMAN,
    ROLES.LGA_FOCAL_PERSON,
    ROLES.LGA_CHAIRMAN,
  ],
  [ROLES.STATE_ADMIN]: [ROLES.LGA_FOCAL_PERSON, ROLES.LGA_CHAIRMAN],
})

// Roles that require a State selection when creating an account
export const ROLES_NEEDING_STATE = Object.freeze([
  ROLES.STATE_ADMIN,
  ROLES.STATE_ALGON_CHAIRMAN,
  ROLES.LGA_FOCAL_PERSON,
  ROLES.LGA_CHAIRMAN,
])

// Roles that require an LGA selection when creating an account
export const ROLES_NEEDING_LGA = Object.freeze([
  ROLES.LGA_FOCAL_PERSON,
  ROLES.LGA_CHAIRMAN,
])
